import { render, staticRenderFns } from "./UpdateDisputeStatusForm.vue?vue&type=template&id=87bb1a9e&scoped=true&"
import script from "./UpdateDisputeStatusForm.vue?vue&type=script&lang=js&"
export * from "./UpdateDisputeStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bb1a9e",
  null
  
)

export default component.exports